// =========================================================
// * Vue Material Dashboard PRO - v1.4.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vue-material-dashboard-pro
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
import api from './api/api.js';
import services from '@/api/services';
import Vue from 'vue';
import VueRouter from 'vue-router';
import VScrollLock from 'v-scroll-lock';
import VueSmoothScroll from 'vue2-smooth-scroll';
import Swal from 'sweetalert2';
import DashboardPlugin from './material-dashboard';

// Plugins
import App from './App.vue';
import Chartist from 'chartist';

// router setup
import routes from './routes/routes';

// plugin setup
Vue.use(VueRouter);
Vue.use(DashboardPlugin);
Vue.use(VScrollLock);
Vue.use(VueSmoothScroll, {
  duration: 400,
  updateHistory: false,
});

Vue.mixin({
  methods: {
    alertSuccess(message) {
      this.$notify({
        timeout: 2500,
        message,
        icon: 'add_alert',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: 'success',
      });
    },
    alertError(message) {
      this.$notify({
        timeout: 2500,
        message,
        icon: 'bug_report',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: 'danger',
      });
    },
    syncOfferInfo() {
      return api
        .get(services.getSession, {
          getSession: true,
        })
        .then(data => {
          const offerId = parseInt(this.$route.query.offerId);

          if (
            offerId !== 0 &&
            (!data.offerInfo || offerId !== data.offerInfo.id)
          ) {
            return api
              .get(services.getOffer, {
                offerId: this.$route.query.offerId,
              })
              .then(
                () => {
                  return api.get(services.getSession, {
                    getSession: true,
                  });
                },
                error => {
                  this.alertError(error);
                },
              );
          } else if (
            (offerId && data.offerInfo && offerId === data.offerInfo.id) ||
            offerId === 0
          ) {
            return data;
          } else if (data.offerInfo && !offerId) {
            return Swal.fire({
              title: 'Nastavi proces?',
              text: `U sesiji je pokrenut proces ponude. Nastavi?`,
              type: 'warning',
              showCancelButton: true,
              confirmButtonClass: 'md-button md-success btn-fill',
              cancelButtonClass: 'md-button md-danger btn-fill',
              confirmButtonText: 'Nastavi!',
              cancelButtonText: 'Otkaži',
              buttonsStyling: false,
            }).then(result => {
              if (result.value) {
                if (data.job) {
                  this.job = data.job;
                  this.$router.push({
                    path: 'job',
                    query: {
                      offerId: data.offerInfo.id,
                    },
                  });
                }
                return data;
              } else {
                api.post(services.offers.deleteOffer, {
                  deleteCachedOffer: true,
                });
                Swal.fire({
                  title: 'Proces nije završen!',
                  text: 'Proces nije završen. Samo za demonstraciju',
                  type: 'danger',
                  confirmButtonClass: 'md-button md-success btn-fill',
                  buttonsStyling: false,
                });
              }
            });
          }
        });
    },
    getSession() {
      return api
        .get(services.getSession, {
          getSession: true,
        })
        .then(() => {});
    },
    priceDisplay(amount) {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
      }).format(amount);
    },
  },
});

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  mode: 'history',
  scrollBehavior: to => {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
  linkExactActiveClass: 'nav-item active',
});

// global library setup
Vue.prototype.$Chartist = Chartist;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  data: {
    window: {
      width: 0,
      height: 0,
    },
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
  },
});
